import {performValidation} from "./apple-pay-rest-client";
import {
  merchantIdentifier,
  merchantDisplay,
  APPLE_PAY_VERSION_NUMBER, COUNTRY_CODE, CURRENCY_CODE, merchantCapabilities, supportedNetworks
} from "./applePayUtil";

// export const isPaymentRequestAvailable = () => {
//   return new Promise((resolve, reject) => {
//     try {
//       const enabled = window.PaymentRequest ? true : false;
//       resolve(enabled);
//     } catch (err) {
//       reject(err);
//     }
//   });
// };

const getPaymentDetails = (currencyCode, label, amount) => {
  return {
    // displayItems: items.map((item) => {
    //   return {
    //     label: item.label,
    //     amount: {
    //       value: `${Number(item.amount).toFixed(2)}`,
    //       currency: currencyCode,
    //     },
    //   };
    // }),
    total: {
      label: label,
      amount: {value: `${Number(amount).toFixed(2)}`, currency: currencyCode},
    },
  };
};

const applePayMethod = {
  supportedMethods: "https://apple.com/apple-pay",
  data: {
    version: APPLE_PAY_VERSION_NUMBER,
    paymentMethodType: "credit",
    merchantIdentifier: merchantIdentifier,
    supportedNetworks: supportedNetworks,
    merchantCapabilities: merchantCapabilities,
    countryCode: COUNTRY_CODE,
  },
};

const paymentOptions = {
  requestPayerName: false,
  requestPayerEmail: false,
  requestPayerPhone: false,
  requestShipping: false,
  // shippingType: "shipping",
};

const paymentRequestValidateMerchant = (event) => {
  console.log('paymentRequestValidateMerchant...');
  const sessionPromise = performValidation(
    event.validationURL,
    merchantIdentifier,
    merchantDisplay,
    window.location.hostname
  );
  event.complete(sessionPromise);
};

// const paymentRequestComplete = (resolve, reject, instrument, isError) => {
//   const resolveStatus = !isError
//     ? PaymentStatus.SUCCESS
//     : PaymentStatus.FAILURE;
//   const completeStatus = !isError ? "success" : "failure";
//   instrument
//     .complete(completeStatus)
//     .then(() => {
//       resolve(resolveStatus);
//     })
//     .catch((err) => {
//       console.log("Complete error:", err);
//       reject(err);
//     });
// };

// const paymentRequestPerformPayment = (
//   resolve,
//   reject,
//   paymentRequest,
//   currencyCode,
//   amount
// ) => {
//   console.log('paymentRequestPerformPayment...');
//   paymentRequest.show()
//     .then((paymentResponse) => {
//         console.log('showPromise.then... paymentResponse ' + JSON.stringify(paymentResponse));
//
//         // if (!hasValidShippingZIPCode(paymentResponse)) {
//         //   paymentResponse.retry({
//         //     paymentMethod: [
//         //       new ApplePayError("shippingContactInvalid", "postalCode", "ZIP Code is invalid"),
//         //     ],
//         //   });
//         //   return;
//         // }
//
//         // Handle authorization with valid details here.
//
//         // // amount must be provided in cents
//         // performApplePayDebit(
//         //   amount * 100,
//         //   currencyCode,
//         //   instrument.details.token.paymentData
//         // )
//         //   .then((response) => {
//         //     if (response.code === 100) {
//         //       console.log("Payment done!");
//         //       paymentRequestComplete(resolve, reject, instrument);
//         //     } else {
//         //       console.log("Payment error in response ", JSON.stringify(response));
//         //       paymentRequestComplete(resolve, reject, instrument, true);
//         //     }
//         //   })
//         //   .catch((err) => {
//         //     console.log("Payment error ", JSON.stringify(err));
//         //     paymentRequestComplete(resolve, reject, instrument, true);
//         //   });
//       },
//       (failure) => {
//         console.log('showPromise failure ', failure);
//         resolve(
//           failure.name === "AbortError"
//             ? PaymentStatus.CANCEL
//             : PaymentStatus.FAILURE
//         );
//         console.log('showPromise failure ' + JSON.stringify(failure));
//       }
//     );
// };

export const createApplePayPaymentRequest = (label, amount) => {
  try {
    console.log('createApplePayPaymentRequest...');
    const paymentDetails = getPaymentDetails(
      CURRENCY_CODE,
      // items,
      label,
      amount
    );
    const paymentRequest = new window.PaymentRequest(
      [applePayMethod],
      paymentDetails,
      paymentOptions
    );

    paymentRequest.onpaymentmethodchange = event => {
      event.updateWith({});
    };

    paymentRequest.onshippingaddresschange = event => {
      event.updateWith({});
    };

    paymentRequest.onmerchantvalidation = paymentRequestValidateMerchant;
    // const showPromise = paymentRequest.show();
    // paymentRequestPerformPayment(
    //   resolve,
    //   reject,
    //   paymentRequest,
    //   currencyCode,
    //   amount
    // );
    return paymentRequest;
  } catch (err) {
    console.log('createApplePayPaymentRequest error ', err);
    console.log('createApplePayPaymentRequest error ' + err?.message);
    return null;
  }
};
